const FROM_BREADCRUMB_PARAM_NAME = '_b_';
export const setFromBreadcrumb = (searchParams: URLSearchParams): URLSearchParams => {
    const out = new URLSearchParams(searchParams.toString());
    out.set(FROM_BREADCRUMB_PARAM_NAME, '1');
    return out;
};

export const removeFromBreadcrumb = (searchParams: URLSearchParams): URLSearchParams => {
    const out = new URLSearchParams(searchParams.toString());
    out.delete(FROM_BREADCRUMB_PARAM_NAME);
    return out;
};

export const isNotFromBreadCrumb = (
    searchParams: URLSearchParams,
): boolean => !searchParams.has(FROM_BREADCRUMB_PARAM_NAME);
